module.exports = __webpack_public_path__ + "static/media/025.e556cfbc.jpg";